module.exports = __webpack_public_path__ + "static/img/szafa_9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_9.jpg
// module id = ly5E
// module chunks = 0